// extracted by mini-css-extract-plugin
export default {"card":"ProfileCard_card__1+k-+"};